<template>
  <div class="login">
    <div class="info">
      <!-- <div class="lang">
        <h3 style="margin-right: 20px">{{ $t("info.lang.language") }}</h3>
        <el-select v-model="lang" placeholder="请选择语言">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div> -->
      <img src="../assets/newImg/login1.png" style="margin: 80px 0" />
      <img src="../assets/newImg/login2.png" />
      <div v-if="type1 == 'login'">
        <!-- <img src="../assets/newImg/login3.png" class="login3" /> -->
        <el-tabs v-model="activeName" :stretch="true">
          <el-tab-pane label="密码登录" name="login1">
            <div style="width: 100%; height: 30px"></div>

            <div class="line">
              <h3>{{ $t("info.lang.account") }}</h3>
              <div class="input">
                <el-input v-model="account" placeholder="请输入手机号"></el-input>
              </div>
            </div>
            <div class="line">
              <h3>{{ $t("info.lang.password") }}</h3>
              <div class="input">
                <el-input placeholder="请输入密码" v-model="psw" show-password></el-input>
              </div>
            </div>

            <div class="button">
              <el-button type="primary" @click="login('psd')">{{
                $t("info.lang.login")
              }}</el-button>

              <el-button type="info" @click="login1"> 游客登陆 </el-button>
            </div>
          </el-tab-pane>

          <el-tab-pane label="短信登录" name="login2">
            <div style="width: 100%; height: 30px"></div>

            <div class="line">
              <h3>{{ $t("info.lang.account") }}</h3>
              <div class="input">
                <el-input v-model="account" placeholder="请输入手机号"></el-input>
              </div>
            </div>

            <div class="line">
              <h3>验证码</h3>
              <div class="input">
                <el-input v-model="code" placeholder="请输入验证码"></el-input>
                <el-button type="primary" v-if="time == 0"
                  ><p class="font" @click="timeOrder">获取验证码</p></el-button
                >
                <el-button type="info" v-else
                  ><p class="font">{{ time }}s</p></el-button
                >
              </div>
            </div>

            <div class="button">
              <el-button type="primary" @click="login('code')">{{
                $t("info.lang.login")
              }}</el-button>

              <el-button type="info" @click="login1"> 游客登陆 </el-button>
            </div>
          </el-tab-pane>

          <div class="line1">
            <p @click="type1 = 'register'">账号注册</p>
            <p @click="type1 = 'password'">忘记密码</p>
          </div>

          <div class="line2">
            <p>——————————</p>
            <p style="margin: 0 10px">第三方账号登录</p>
            <p>——————————</p>
          </div>

          <div class="wxImg">
            <img src="../../common/images/wx.png" class="wx" @click="wxLogin" />
          </div>
        </el-tabs>
      </div>

      <div v-if="type1 == 'register'">
        <!-- <img src="../assets/newImg/login3.png" class="login3" /> -->

        <div style="width: 100%; height: 30px"></div>

        <div class="line">
          <h3>{{ $t("info.lang.account") }}</h3>
          <div class="input">
            <el-input v-model="account" placeholder="请输入手机号"></el-input>
          </div>
        </div>
        <div class="line">
          <h3>验证码</h3>
          <div class="input">
            <el-input v-model="code" placeholder="请输入验证码"></el-input>
            <el-button type="primary" v-if="time == 0"
              ><p class="font" @click="timeOrder">获取验证码</p></el-button
            >
            <el-button type="info" v-else
              ><p class="font">{{ time }}s</p></el-button
            >
          </div>
        </div>

        <div class="line">
          <h3>密码</h3>
          <div class="input">
            <el-input v-model="psw" placeholder="请输入密码" show-password></el-input>
          </div>
        </div>

        <div class="button">
          <el-button type="primary" @click="register" style="width: 100%">注册</el-button>
        </div>

        <div class="line1">
          <p @click="type1 = 'login'">已有账号，请点击登录</p>
        </div>

        <div class="line2">
          <p>——————————</p>
          <p style="margin: 0 10px">使用微信注册</p>
          <p>——————————</p>
        </div>

        <div class="wxImg">
          <img src="../../common/images/wx.png" class="wx" @click="wxLogin" />
        </div>
      </div>

      <div v-if="type1 == 'password'">
        <!-- <img src="../assets/newImg/login3.png" class="login3" /> -->

        <div style="width: 100%; height: 30px"></div>

        <div class="line">
          <h3>{{ $t("info.lang.account") }}</h3>
          <div class="input">
            <el-input v-model="account" placeholder="请输入手机号"></el-input>
          </div>
        </div>
        <div class="line">
          <h3>验证码</h3>
          <div class="input">
            <el-input v-model="code" placeholder="请输入验证码"></el-input>
            <el-button type="primary" v-if="time == 0"
              ><p class="font" @click="timeOrder">获取验证码</p></el-button
            >
            <el-button type="info" v-else
              ><p class="font">{{ time }}s</p></el-button
            >
          </div>
        </div>

        <div class="line">
          <h3>新密码</h3>
          <div class="input">
            <el-input v-model="psw" placeholder="请输入新密码" show-password></el-input>
          </div>
        </div>

        <div class="button">
          <el-button type="primary" @click="setpsd" style="width: 100%">确定</el-button>
        </div>

        <div class="line1">
          <p @click="type1 = 'login'">已有账号，请点击登录</p>
        </div>
      </div>
    </div>

    <img src="../assets/newImg/banner.jpg" class="pic" />
  </div>
</template>

<script>
import { register, login, verify, sendCode, setpsd } from "../assets/api/index";
import md5 from "js-md5";
export default {
  data() {
    return {
      type: "",
      account: "",
      psw: "",
      nickname: "",
      nickname1: "",
      time: 0,
      code: "",
      lang: "zh",
      activeName: "login1",
      type1: "login",
      timmer: "",
    };
  },
  methods: {
    wxLogin() {
      window.location.href = "https://api.wh12345.net/o2user/auth/wxLogin.php";
    },
    timeOrder() {
      if (!this.account) {
        this.$message.error("手机号不能为空");
        return;
      }

      var data = {
        mobile: this.account,
      };

      sendCode(data).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$message.success("验证码已发送");
        } else {
          this.$message.error("验证码发送失败");
        }
      });
      this.time = 30;

      this.timmer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timmer);
        }
      }, 1000);
    },

    login(e) {
      if (!this.account) {
        this.$message.error(this.$t("info.lang.loginError1"));
      } else {
        if (e == "code") {
          if (!this.code) {
            this.$message.error("请填写验证码");
            return;
          } else {
            var data = {
              acount: this.account,
              code: this.code,
            };
          }
        } else {
          if (!this.psw) {
            this.$message.error("请填写密码");
            return;
          } else {
            var data = {
              acount: this.account,
              psd: md5(this.psw),
            };
          }
        }
        login(data).then((res) => {
          if (res.code == 0) {
            var info = JSON.stringify({ token: res.data.token, type: "user" });
            localStorage.setItem("userInfo", info);
            this.$router.push({ name: "index" });
          } else {
            this.$message.error("账号密码错误");
          }
          // ;
        });
      }
    },
    register() {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.account || !this.psw || !this.code) {
        this.$message.error("您还有未填项");
        return;
      }

      if (!reg.test(this.account)) {
        this.$message.error("请输入正确的手机号");
        return;
      }

      var data = {
        mobile: this.account,
        code: this.code,
      };
      verify(data).then((res) => {
        console.log(res);

        if (res.code == 0) {
          register({
            acount: this.account,
            code: this.code,
            psd: md5(this.psw),
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success("注册成功");
              this.login("psd");
            } else {
              this.$message.error(res.info);
            }
          });
        } else {
          this.$message.error("验证码输入错误");
        }
      });
    },

    setpsd() {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.account || !this.psw || !this.code) {
        this.$message.error("您还有未填项");
        return;
      }

      if (!reg.test(this.account)) {
        this.$message.error("请输入正确的手机号");
        return;
      }

      var data = {
        mobile: this.account,
        code: this.code,
      };
      verify(data).then((res) => {
        console.log(res);

        if (res.code == 0) {
          setpsd({
            acount: this.account,
            code: this.code,
            psd: md5(this.psw),
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success("更改密码成功成功");
              this.type1 = "login";
            } else {
              this.$message.error(res.info);
            }
          });
        } else {
          this.$message.error("验证码输入错误");
        }
      });
    },

    login1() {
      var info = JSON.stringify({ type: "visitor" });

      localStorage.setItem("userInfo", info);
      this.$router.replace({ name: "index" });
      document.o2.firstLogin = true;
    },
  },
  watch: {
    activeName(val) {
      if (val == "visitor") {
        this.vnum = this.getRandomSixNum();
        this.nickname1 = `游客${this.vnum}`;
      }
    },
  },

  beforeCreate() {
    if (localStorage.getItem("userInfo")) {
      this.$router.push({ name: "index" });
    }
  },

  created() {
    if (localStorage.getItem("locale")) {
      this.lang = localStorage.getItem("locale");
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;

  .info {
    width: 367px;
    height: 100%;
    background: rgba($color: #0e0e0e, $alpha: 0.8);
    box-shadow: 3.94px 4.53px 21px 6px rgba(255, 43, 43, 0.1);
    padding: 0 95px;
    h1 {
      padding-top: 60px;
      font-size: 26px;
      font-weight: 800;
      color: white;
      margin-bottom: 44px;
    }
    .button {
      text-align: left;
      margin-top: 35px;
    }
    .lang {
      display: flex;
      position: fixed;
      bottom: 30px;
      align-items: center;
      color: white;
      right: 30px;
      ::v-deep .el-input__inner {
        background: transparent;
        color: white;
      }
    }

    .login3 {
      display: flex;
      position: fixed;
      bottom: 30px;
      align-items: center;
      color: white;
    }

    ::v-deep .el-tabs__item.is-active {
      color: #ff0000;
    }
    ::v-deep .el-tabs__item {
      color: white;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #ff0000;
    }
    .chooseType {
      .el-button {
        font-size: 20px;
        width: 70%;
        margin-bottom: 30px;
      }
      .el-button--danger {
        background-color: #ff0000;
        border-color: #ff0000;
      }
    }
  }
  .pic {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }

  .el-button--primary {
    background-color: #ff0000;
    border-color: #ff0000;
    width: 48%;
  }

  .el-button--info {
    width: 48%;
  }
  .input1 {
    width: 49%;
    display: inline-block;
  }
  .line1 {
    margin-top: 20px;
    color: white;
    justify-content: space-around;
    display: flex;
    p {
      font-size: 12px;
      cursor: pointer;
    }
    p:hover {
      color: #ff0000;
    }
  }

  .line2 {
    justify-content: center;
    display: flex;
    color: #828282;
    font-size: 12px;
    margin-top: 30px;
  }
  .line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    h3 {
      font-size: 20px;
      color: white;
      text-align: left;
      margin-right: 12px;
      width: 100px;
    }
    .input {
      position: relative;
      flex: 1;

      input {
        background: transparent;
        -webkit-appearance: none;

        background-image: none;
        border-radius: 4px;
        border: 1px solid #1a1a1a;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;
        font-size: 12px;
      }

      .el-button {
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }

  .toEmail {
    text-align: center;
    font-size: 14px;

    font-weight: 400;
    margin-top: 10px;
    color: #828282;
    cursor: pointer;
  }
}
a {
  text-decoration: none;
}

.font {
  width: 85px;
}

.wx {
  width: 50px;
  margin-top: 20px;
  cursor: pointer;
}

#wx {
  width: 300px;
  height: 300px;
  background: white;
  margin-left: 40px;
}
@media screen and (max-width: 500px) {
  .login {
    .info {
      width: 100%;
    }
    .pic {
      width: 0;
    }
  }
}
</style>
